// import { HowDropshippingWorkContent } from "../../helper/constants";
import React from "react";
import SectionOneImg from "../../assets/images/how-dropshipping/section_one.png";
import SectionTwoImg from "../../assets/images/how-dropshipping/section_two.png";
import WebButton from "../../../component/library/webButton";
import DropShipSteps from "../../component/views/home/dropshipWorkSteps";
import "./style.css";

export default function HowDropshippingWork() {
  const handleWhatsapp = () => {
    // window.open("https://wa.me/message/MKQJBLTLR5GAM1", "_blank");
  };
  return (
    <div>
      {/* Top Banner */}
      <div className="how_dropshipping_banner" />

      {/* Hero / Intro */}
      <div className="how_dropshipping_work_row">
        <div className="how_dropshipping_work_column">
          <h1 className="page_title">How Does <span>Importerr</span> Work?</h1>
          <p className="lead_para">
            Importerr is your complete solution for sourcing products from China and delivering
            them directly to India—whether you are a <strong> business (B2B) </strong> looking to import for resale
            or a <strong> customer (B2C) </strong>  who wants to shop directly. <br />
            We simplify product sourcing, importing, and logistics so you can focus on
            growing your business or enjoying your purchase.
          </p>

          <div className="how_dropshipping_work_column_btn">
            <WebButton
              className="active_btn_with_shadow"
              text=" &nbsp;  &nbsp;  Speak to an expert  &nbsp;  &nbsp; "
              onClick={handleWhatsapp}
            />
          </div>
        </div>
        <div className="how_dropshipping_work_column">
          <img
            src={SectionOneImg}
            className="how_dropshipping_work_section_img"
            alt="Importerr workflow illustration"
          />
        </div>
      </div>

      {/* B2B Section */}
      <section className="card_section" id="b2b">
        <h2 className="section_head">For Businesses (B2B Suppliers &amp; Sellers)</h2>

        <div className="card_grid">
          <div className="info_card">
            <h3>Product Sourcing from China</h3>
            <ul className="tick_list">
              <li>Importerr helps you find trusted Chinese suppliers for any product category.</li>
              <li>We ensure verified quality, competitive pricing, and wide product choices.</li>
            </ul>
          </div>

          <div className="info_card">
            <h3>Integration with Your Platforms</h3>
            <ul className="tick_list">
              <li>Import directly to your  <strong>website, Shopify store, or Amazon seller account.</strong></li>
              <li>Our system allows you to seamlessly list and manage products without hassle.</li>
            </ul>
          </div>

          <div className="info_card">
            <h3>Logistics &amp; Import Handling</h3>
            <ul className="tick_list">
              <li>Importerr takes care of customs, shipping, and clearance.</li>
              <li>Products are shipped directly to your warehouse or delivered straight to your customers (1-Piece-style).</li>
            </ul>
          </div>

          <div className="info_card">
            <h3>Grow Your Business</h3>
            <ul className="tick_list">
              <li>Save time, reduce costs, and scale your product range instantly without heavy investment.</li>
            </ul>
          </div>
        </div>
      </section>

      {/* B2C Section */}
      <section className="card_section alt" id="b2c">
        <div className="how_dropshipping_work_row">
          <div className="how_dropshipping_work_column">
            <img
              src={SectionTwoImg}
              className="how_dropshipping_work_section_img"
              alt="Shopping and delivery"
            />
          </div>

          <div className="how_dropshipping_work_column">
            <h2 className="section_head">For Customers (B2C Buyers)</h2>
            <div className="info_card flat">
              <h3>Shop Products from China</h3>
              <ul className="dot_list">
                <li>Browse and order products directly through <strong>Importerr</strong>.</li>
                <li>Get access to <strong>millions of products </strong> at global prices.</li>
              </ul>

              <h3>Secure Purchase &amp; Payment</h3>
              <ul className="dot_list">
                <li>Place your order with safe and simple checkout.</li>
                <li>Transparent pricing with no hidden costs.</li>
              </ul>

              <h3>Logistics &amp; Delivery</h3>
              <ul className="dot_list">
                <li>Importerr manages shipping, customs, and last-mile delivery.</li>
                <li>Your order is delivered directly to your doorstep in India.</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Process Steps (existing component kept) */}
      <DropShipSteps headShow={false} />

      {/* Why Importerr */}
      <section className="why_section">
        <div className="our_knowledge_box">
          <div className="border_box_one"></div>
          <h2 className="section_head center">Why Importerr?</h2>
          <ul className="badge_list">
            <li>✅ <strong>End-to-End Solution</strong> — from sourcing to delivery</li>
            <li>✅ <strong>For Both Businesses &amp; Customers </strong> —  B2B and B2C support</li>
            <li>✅ <strong>Trusted Network</strong> in China &amp; India</li>
            <li>✅ <strong>Reliable, Cost-Efficient </strong> and Fast logistics</li>
          </ul>
          <div className="border_box_two"></div>
        </div>
      </section>
    </div>
  );
}
